import letterNamingAndSoundsConfig from "./customConfigs/letterNamingAndSoundsConfig";

export default function listAllCustomConfigurations() {
  // list all custom configurations here
  return [
    letterNamingAndSoundsConfig,
  ];
}